import { render, staticRenderFns } from "./StaticTable.vue?vue&type=template&id=50b9b723&"
import script from "./StaticTable.vue?vue&type=script&lang=ts&"
export * from "./StaticTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports